export const SMALL_DEVICE_BREAK_POINT = 928;
export const CREATE_ADDON_URL = '/dashboard/add-ons/create';
export const CREATE_EVENT_URL = '/create';
export const ADD_ONS_LIMIT = 15;
export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const SHOW_ALL = 'ALL';

// Add-on listings section create-edit form
export const SELECT_ALL_LISTINGS = 'ALL';
export const SELECT_SOME_LISTINGS = 'SOME';
export const LISTINGS_LIMIT = 300; // Increasing Listing Limit to meet design requirement for AOI-198(Limit quantity/timeslot)
export const HOSTED_LISTING_LIMIT = 300;
export const RATE_LIMIT = 50;
export const ALLOWED_LISTING_STATES = ['POSTED', 'DRAFT'];
export const ADD_ON_LISTING_STATES = ['DRAFT', 'POSTED', 'EXPIRED', 'ARCHIVED'];
export const SELECTED_LISTINGS_APPLIED = 'SELECTED_EVENTS_APPLIED';
export const ALL_LISTINGS_APPLIED = 'ALL_EVENTS_APPLIED';
export const NO_LIVE_LISTINGS = 'NO_LIVE_EVENTS';
export const EDIT_LISTINGS = 'EDIT';
export const CREATE_PAGE = 'CREATE';
export const POSTED = 'POSTED';
export const DRAFT = 'DRAFT';

// Add-on listing date format schema
export const DATE_SCHEMA_WITH_YEAR = { month: 'short', day: '2-digit', year: 'numeric' };
export const DATE_SCHEMA_WITH_TIME = { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' };
export const DATE_SCHEMA_WITHOUT_YEAR = { month: 'short', day: '2-digit' };
export const DATE_SCHEMA_WITHOUT_DATE = { hour: '2-digit', minute: '2-digit' };

// Add-on listing timeslot section
export const SPECIFIC = 'SPECIFIC';
